import { Helmet } from 'react-helmet';
import PortDetail from 'src/features/PortDetail';
import MainLayout from 'src/layouts';

const PortDetailPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Port Detail</title>
      </Helmet>
      <PortDetail />
    </MainLayout>
  );
};

export default PortDetailPage;
